import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'component-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  year: any;

  constructor() { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }
}
